import { render, staticRenderFns } from "./shopingSearch.vue?vue&type=template&id=35913915&"
import script from "./shopingSearch.vue?vue&type=script&lang=js&"
export * from "./shopingSearch.vue?vue&type=script&lang=js&"
import style0 from "./shopingSearch.vue?vue&type=style&index=0&id=35913915&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports